.settings {
  display: flex;
  margin: 24px 0;
}

.settingsFontFamily {
  flex: 0 1 100%;
  z-index: 4;
}

.heading {
  color: var(--color-easil-gray-x-dark);
  display: block;
  margin-bottom: 8px;
}

.dropdown input {
  color: var(--color-easil-black) !important;
}
